import apiClient from './api.ts';
import {RoomSchema} from "@/types/room_schema.ts";

export default {
    async getAllRooms(isActive: boolean, page: number, pageSize: number) {
        return await apiClient.get(`rooms?is_active=${isActive}&page=${page}&offset=${pageSize}`);
    },
    async createRoom(room: RoomSchema) {
        return await apiClient.post(`rooms`, room);
    },
    async updateRoom(roomId: number, room: { name: string; capacity: number; is_available: boolean }) {
        return await apiClient.put(`rooms/${roomId}`, room);
    },
    async deleteRoom(roomId: number) {
        return await apiClient.delete(`rooms/${roomId}`);
    },
    async archiveRoom(roomId: number) {
        return await apiClient.put(`rooms/${roomId}/archive`);
    },
    async unarchiveRoom(roomId: number) {
        return await apiClient.put(`rooms/${roomId}/unarchive`);
    },
    async getAvailableRooms() {
        return await apiClient.get(`rooms/available`);
    }
};
